<template>

  <div class="app-layout" >
    <div class="left-pane" v-if="$media.desktop">
      <AppLogo />
      <img alt="" id="preview" src="../assets/images/app-preview.png" v-if="showAppPreview" />
    </div>
    <main class="right-pane">
      <div class="right-pane-body">
        <div :style="{ maxWidth: contentMaxWidth, minWidth: contentMinWidth }" class="content">
          <AppLogoMobile class="app-logo-mobile" v-if="!$media.desktop" colored />
          <slot />
        </div>
      </div>
      <div class="right-pane-footer" v-if="$slots.footer">
        <slot name="footer" />
      </div>
    </main>
  </div>
</template>

<script>
  import BaseButton from './BaseButton';
  import AppLogo from './AppLogo';
  import AppLogoMobile from './AppLogoMobile'

  export default {
    name: 'AppLayout',
    components: { AppLogo, AppLogoMobile, BaseButton },
    props: {
      showAppPreview: {
        type: Boolean,
        default: true,
      },
      contentMaxWidth: {
        type: String,
        required: false,
        default: '46rem',
      },
      contentMinWidth: {
        type: String,
        required: false,
        default: '55%',
      },
    },
    data() {
      return {
        show: true
      }
    }
  };
</script>

<style lang="scss" scoped>
  .app-layout {
    display: flex;
    min-height: 100vh;
    @include onMobile {
      flex-direction: column;
    }
  }

  .left-pane {
    flex: 1 0;
    display: none;
    justify-content: center;
    align-items: center;
    background: $logoPaneBackground;
    max-height: 100vh;
    position: sticky;
    top: 0;
    padding: 5rem;

    @include onDesktop {
      display: flex;
    }
  }

  .right-pane {
    position: relative;
    flex: 1;
    display: flex;
    flex-direction: column;
    padding: 1rem 2rem;

    @include onDesktop {
      padding: 3rem 6rem;
    }

    @media (max-width: 1200px) {
      flex: 2;
    }
  }

  .right-pane-body {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .right-pane-footer {
    margin-top: 3rem;
  }

  .app-logo {
    @include onMobile {
      display: block;
      max-width: 20rem;
      margin: 0 auto;
    }

    @include onDesktop {
      max-width: 100%;
    }
  }

  .content {
    overflow: hidden;
    padding: 1rem;
  }

  #preview {
    position: absolute;
    right: 0;
    transform: translateX(50%);
    max-width: 39rem;

    @media (max-width: 1400px) {
      max-width: 24rem;
    }

    @media (max-width: 1200px) {
      display: none;
    }
  }
  .app-logo-mobile{
    width: 100%;
  }
</style>
